import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane, Table } from 'reactstrap';
import classnames from "classnames";
import UiContent from '../../../../Components/Common/UiContent';
import NormativeSection from './Sections/NormativeSection';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import useRedirectEstablishmentActiveContent from '../../../../Components/Hooks/useRedirectEstablishmentActiveContent';


const EstablishmentRecord = () => {
    const location = useLocation();
    const { id } = useParams();
    const redirectEstablishmentActiveContent = useRedirectEstablishmentActiveContent('/establishment/record/establishmentId');

    const breadcrumbLinks = [
        { to: '#', label: 'Centro' },
        { to: '#', label: 'Expediente' },
    ];


    const [activeTab, setActiveTab] = useState("nr");
    const toggle = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    return (
        <React.Fragment>
            <UiContent />
            <div className='page-content'>
                <Container fluid>
                    <BreadCrumb title='Centro' links={breadcrumbLinks} />

                    <Card>
                        <CardHeader>
                            <Nav className="nav-tabs-custom rounded card-header-tabs border-bottom-0" role="tablist">
                                    <NavItem>
                                        <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "pd", })} onClick={() => { toggle("pd"); }} >
                                            Producción
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "op", })} onClick={() => { toggle("op"); }} >
                                            Operaciones
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "nr", })} onClick={() => { toggle("nr"); }} >
                                            Normativa
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "ma", })} onClick={() => { toggle("ma"); }} >
                                            Medio Ambiente
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink style={{ cursor: "pointer" }} className={classnames({ active: activeTab === "sl", })} onClick={() => { toggle("sl"); }} >
                                            Salud
                                        </NavLink>
                                    </NavItem>
                                </Nav>
        
                        </CardHeader>
                        <CardBody>
                            <TabContent activeTab={activeTab} className="text-muted p-0">
                                <TabPane tabId="pd" id="production">
                                    {/* <ProductionSection id={id} /> */}
                                    <h5 className='tx-muted'>pronto</h5>
                                </TabPane>

                                <TabPane tabId="op" id="operation">
                                    {/* <OperationSection /> */}
                                    <h5 className='tx-muted'>pronto</h5>
                                </TabPane>

                                <TabPane tabId="nr" id="normative">
                                    <NormativeSection id={id} />
                                </TabPane>

                                <TabPane tabId="ma" id="medio">
                                    {/* <EnvironmentSection /> */}
                                    <h5 className='tx-muted'>pronto</h5>
                                </TabPane>

                                <TabPane tabId="sl" id="logistic">
                                    {/* <HealthSection /> */}
                                    <h5 className='tx-muted'>pronto</h5>
                                </TabPane>
                            </TabContent>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default EstablishmentRecord;
